import { graphql } from "gql";

const INTERNAL_ADMIN_ORGANIZATION_CREATE_MUTATION = graphql(`
  mutation InternalAdminOrganizationCreate(
    $input: InternalAdminCreateOrganizationInput!
  ) {
    internalAdminCreateOrganization(input: $input) {
      ...InternalAdminOrganization
    }
  }
`);

export { INTERNAL_ADMIN_ORGANIZATION_CREATE_MUTATION };
